import "./RecentMissions.css";
import { useState } from "react";
import RecentMissionsSearch from "./RecentMissionsSearch/RecentMissionsSearch";
import RecentMissionsDisplay from "./RecentMissionsDisplay/RecentMissionsDisplay";

const RecentMissions = () => {
  const [recentMissions, setRecentMissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="recent-missions">
      <h1 className="recent-missions-title">Missions Récentes</h1>
      <RecentMissionsSearch
        setRecentMissions={setRecentMissions}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
      />
      {isLoading ? (
        <div className="loading-indicator">
          Chargement des missions récentes...
        </div>
      ) : (
        <RecentMissionsDisplay recentMissions={recentMissions} />
      )}
    </div>
  );
};

export default RecentMissions;
